import { Component, OnInit, input, output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of, take } from 'rxjs';
import { PropertyAbstract } from '../../models/propertyAbstract';
import { AuthenticationService } from '../../services/AuthenticationService';
import { PropertyService } from '../../services/PropertyService';
import { BiddingHistoryDialogComponent } from '../dialog/bidding-history-dialog.component';

@Component({ standalone: false,
  selector: 'app-property-abstract',
  templateUrl: './property-abstract.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./property-abstract.component.scss'] 
})
export class PropertyAbstractComponent implements OnInit {
  
  readonly propertyAbstract = input<PropertyAbstract>();
  readonly disabled = input<boolean>(false);
  readonly readonly = input<boolean>(false);
  readonly portfolioContext = input<boolean>(true); //this will hide the portfolio button
  readonly propertyIdClick = output<PropertyAbstract>();

  public routerPath="/properties";

  constructor(private propertyService:PropertyService, private authService:AuthenticationService, private dialog: MatDialog) {
    
  }

  ngOnInit() { }

  ngAfterViewInit(){ }

  public getSaleType(pa:PropertyAbstract){
    if(pa.saleType){
      return this.propertyService.getSaleTypeById(pa.saleType);
    }
    return of(undefined);
  }

  public getClient(clientId:number){
    return this.authService.getClientById(clientId);
  }

  get isClient(){
    return this.authService.currentUserValue?.isClient;
  }

  get isAuction(){
    return this.propertyAbstract()?.auctionType===1;
  }

  get isMakeOfferBuyNow(){
    return this.propertyAbstract()?.auctionType===2;
  }

  get isRegularSale(){
    return this.propertyAbstract()?.auctionType===3;
  }

  get isCallForOffer(){
    return this.propertyAbstract()?.auctionType===4;
  }

  public onBidsClick(){
    if(!this.disabled()) this.propertyBidHistoryDialog();
  }

  private propertyBidHistoryDialog(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data={pa:this.propertyAbstract()};
    dialogConfig.minWidth=800;
    this.dialog.open(BiddingHistoryDialogComponent, dialogConfig).afterClosed().pipe(take(1)).subscribe(value=>{
      if(value){
        //do nothing
      }
      else{
        //do nothing
      }
    });
  }

  public onPropertyIdClick(){
    this.propertyIdClick.emit(this.propertyAbstract()!);
  }


}
